//import axios from 'axios';
//import authHeader from './auth-header';
import api from "./api"; //Added 2024-04-18 for refreshToken

class UserTuneDataService {
  getAll(data) {
    //return axios.get(process.env.VUE_APP_ROOT_API + "usertunes", { headers: authHeader(), params: data }); //Replaced 2024-04-18 due to RefreshToken
    return api.get("usertunes", { params: data });
  }

  get(id, params = {}) {
    //return axios.get(process.env.VUE_APP_ROOT_API + `usertunes/${id}`, { headers: authHeader()}); //Replaced 2024-04-18 due to RefreshToken
    return api.get(`usertunes/${id}`, { params });
  }

  create(data) {
    //return axios.post(process.env.VUE_APP_ROOT_API + `usertunes`, data, { headers: authHeader()}); //Replaced 2024-04-18 due to RefreshToken
    return api.post(`usertunes`, data);
  }

  /*findByTitle(title) {
    return axios.get(process.env.VUE_APP_ROOT_API + `usertunes?title=${title}`, { headers: authHeader() });
  }*/
}

export default new UserTuneDataService();